import { defineStore } from 'pinia'
import api from '../services/api'

export interface User {
  id: string
  name: string
  email: string
  role?: string
}

interface LoginResponse {
  token: string
  user: User
}

export const useAuthStore = defineStore('auth', {
  state: () => {
    return {
      token: localStorage.getItem('auth_token') || null as string | null,
      user: null as User | null,
    }
  },

  getters: {
    isAuthenticated: (state) => !!state.token,
  },

  actions: {
    setAuth(token: string, user: User) {
      this.token = token
      this.user = user
      localStorage.setItem('auth_token', token)
      localStorage.setItem('auth_user', JSON.stringify(user))
    },

    clearAuth() {
      this.token = null
      this.user = null
      localStorage.removeItem('auth_token')
      localStorage.removeItem('auth_user')
    },

    loadAuthFromStorage() {
      const token = localStorage.getItem('auth_token')
      const userStr = localStorage.getItem('auth_user')
      if (token && userStr) {
        this.token = token
        this.user = JSON.parse(userStr)
      }
    },

    async fetchUserDetails() {
      if (!this.token) {
        throw new Error('No token available')
      }

      try {
        const response = await fetch(api.me(), {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${this.token}`,
            'Content-Type': 'application/json',
          },
        })

        if (!response.ok) {
          if (response.status === 401 || response.status === 403) {
            // Token is invalid or forbidden, clear auth
            this.clearAuth()
            throw new Error(response.status === 403 ? 'Forbidden' : 'Unauthorized')
          }
          throw new Error('Failed to fetch user details')
        }

        const user: User = await response.json()
        this.user = user
        localStorage.setItem('auth_user', JSON.stringify(user))
        return user
      } catch (error) {
        throw error
      }
    },
  },
})

